<p-dialog
  header="Detalle de Orden de Compra"
  [(visible)]="visible"
  [modal]="true"
  (onHide)="onHideDataDialog()"
  [style]="{ width: '80%' }"
>
  <div class="field col-12 md:col-12 mb-4">
    <p-fieldset legend="Detalles del documento" [toggleable]="true">
      <div class="grid">
        <div class="field col-12 md:col-4">
          <label>
            <b> Fecha de Entrega: </b
            >{{ detailPurchaseOrder['delivery_at'] | date: 'shortDate' }}</label
          >
        </div>
        <div class="field col-12 md:col-4">
          <label
            ><b>Términos de Pago:</b>
            {{ detailPurchaseOrder['paymentTermsId'] }}</label
          >
        </div>
        <div class="field col-12 md:col-4">
          <label><b>Impuesto: </b>{{ detailPurchaseOrder['taxId'] }}</label>
        </div>
      </div>
      <div class="grid">
        <div class="field col-12 md:col-5">
          <label
            ><b>Proveedor:</b> {{ detailPurchaseOrder['providerName'] }}</label
          >
        </div>

        <div class="field col-12 md:col-7">
          <label
            ><b>Documento:</b>
            {{ detailPurchaseOrder['numberDocument'] }}</label
          >
        </div>
      </div>
    </p-fieldset>
  </div>
  <div class="field col-12 md:col-12 mb-4">
    <p-fieldset legend="Datos adicionales" [toggleable]="false">
      <div class="grid">
        <div class="field col-12 md:col-4">
          <label
            ><b>Estado de Orden de Compra:</b>
            {{ detailPurchaseOrder['orderStatusName'] }}</label
          >
        </div>
        <div class="field col-12 md:col-4">
          <label
            ><b>Estado Recepción:</b>
            {{ detailPurchaseOrder['receptionStatusName'] }}</label
          >
        </div>
        <div class="field col-12 md:col-4">
          <label
            ><b>Estado Factura:</b>
            {{ detailPurchaseOrder['invoiceStatusName'] }}</label
          >
        </div>
      </div>
      <div class="grid">
        <div class="field col-12 md:col-4">
          <label><b>Precio de Compra Total:</b> S/{{ precioTotal }}</label>
        </div>

        <div class="field col-12 md:col-4">
          <label
            ><b>Cantidad de Productos Solicitados:</b> {{ quantity }}</label
          >
        </div>
        <div class="field col-12 md:col-4">
          <label
            ><b>Cantidad de Productos Recibidos:</b>
            {{ quantityReceived }}</label
          >
        </div>
      </div>
    </p-fieldset>
  </div>
  <ami-table-actions
    [settings]="table.settings"
    [data]="table.data"
  ></ami-table-actions>
</p-dialog>
